var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBeer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCD00"
    },
    d: "M395.682,95.678L235.984,75.662L256,512h96.763V405.609c0-30.473,3.024-60.871,9.029-90.746 l24.887-123.83C393.003,159.561,396.001,127.603,395.682,95.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE477"
    },
    d: "M116.318,95.678c-0.319,31.924,2.679,63.883,9.004,95.354l24.887,123.83 c6.004,29.876,9.029,60.273,9.029,90.746V512H256V75.662L116.318,95.678z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFE2DD"
    },
    d: "M395.682,95.678C395.361,63.575,391.685,31.506,384.656,0l0,0H256l-20.016,47.839L256,95.678H395.682 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFF5F5"
    },
    d: "M256,0H127.344l0,0c-7.029,31.506-10.705,63.575-11.026,95.678H256V0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBeer);
export default __webpack_public_path__ + "static/media/icon-beer.302b93e02746501aa49ca8d5b8d140ac.svg";
export { ForwardRef as ReactComponent };